const Collection = (props) => {
  const { img, uid, children } = props;

  return (
    <div
      id={`${uid}`}
      style={{
        borderRadius: 10,
        overflow: "hidden",
        backgroundImage: `url(${img})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        width: 350,
        aspectRatio: 1000 / 390,
      }}
    >
      {children}
    </div>
  );
};

export default Collection;
